import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class TextEditorComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentTextEditor | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = true;
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'name',
		]);
	}
}
